import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CustomPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    greenDot: {
      height: '5px',
      width: '5px',
      borderRadius: '50%',
      display: 'inline-block',
      backgroundColor: '#2AAB3F',
    },
    locationStyle: {
      color: 'rgba(255, 255, 255, .38)',
    },
    signStampButtonDiv: {
      paddingRight: 0,
      '& > div > button': {
        width: 'fit-content',
        height: '32px',
        marginTop: '10px',
        letterSpacing: '1.25px',
      },
    },
    signStampButtonContainer: {
      display: 'flex',
    },
    outerCard: {
      padding: 16,
      paddingTop: '0px',
    },
    approvalContainer: {
      '& .cardWithColor': {
        backgroundColor: 'rgba(42, 171, 63, 0.12)',
      },
    },
    pointer: {
      cursor: 'pointer',
      paddingRight: '20px',
    },
    pointer1: {
      cursor: 'pointer',
      paddingRight: '5px',
    },
    accordionOuterGrid: {
      '& .taskOuterGrid': {
        padding: 16,
        margin: '8px 0px',
        paddingTop: '0px',
      },
    },
    actionButtonGrid: {
      '& .actionButton': {
        inlineSize: 'fit-content',
        height: '32px',
        letterSpacing: '1.25px',
        alignSelf: 'self-end',
        marginRight: '26px',
      },
    },

    deleteTaskOnInspection: {
      marginRight: 16,
    },
    updateBtnGrid: {
      '& .updateBtn': {
        inlineSize: 'fit-content',
        height: '32px',
        whiteSpace: 'nowrap',
        letterSpacing: '1.25px',
        alignSelf: 'self-end',
      },
    },
    paper: {
      maxWidth: '170px',
      minWidth: '170px',
      overflow: 'hidden',
      marginLeft: '-35px',
      marginTop: '5px',
      backgroundColor: CustomPalette.elevation.dp24Solid,
    },
    button: {
      padding: '10px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.09)',
      },
    },
    inlineBlock: {
      display: 'inline-block',
    },
    messageIcon: {
      verticalAlign: 'text-bottom',
      marginLeft: 16,
    },
    assignedBackGrid: {
      '& h6': {
        paddingRight: (props: { portrait: boolean }) => (props.portrait ? 30 : 24),
        fontWeight: '400',
        fontSize: '12px',
        letterSpacing: '0.4px',
        maxWidth: (props: { portrait: boolean }) => (props.portrait ? 190 : 260),
        textAlign: 'right',
        lineHeight: '1.25',
      },
    },
    trashIcon: {
      display: 'block',
      paddingTop: '8px',
    },
    trashIconRemoval: {
      display: 'none',
    },
    inspectionDetails: {
      paddingRight: '30px',
      paddingTop: '15px',
      '& > p': {
        margin: '0px 12px 4px 12px',
      },
      '& > h6 > p': {
        margin: '0px 12px ',
        verticalAlign: 'middle ',
      },
    },
    taskDetails: {
      paddingRight: '30px',
      paddingTop: '7px',
    },
    checkbox: {
      flexFlow: 'row',
    },
    reAssignButtonForFI: {
      paddingLeft: '20px',
      '& .reAssignButton': {
        inlineSize: 'fit-content',
        height: '32px',
        letterSpacing: '1.25px',
        alignSelf: 'self-end',
        marginRight: '10px',
      },
    },
    reAssignButtonGrid: {
      '& .reAssignButton': {
        inlineSize: 'fit-content',
        height: '32px',
        letterSpacing: '1.25px',
        alignSelf: 'self-end',
        marginRight: '10px',
      },
    },
    statusAndButtons: {
      paddingTop: '15px',
    },
    checkbox1: {
      paddingTop: '10px',
    },
    taskCheckbox1: {
      paddingTop: '7px',
    },
    buttonDisabled: {
      padding: '10px',
      color: '#918d8d',
    },
  }),
);

export default useStyles;
